import React from "react";
import UserImage from "../../../components/Image/UserImage";
import { Avatar, withStyles } from "@material-ui/core";
import moment from "moment";
import * as mainStyles from "assets/jss/material-dashboard-pro-react.jsx";
import FileBlock from "../../../components/Files/FileBlock";
import Api from "../../../api/Api.js";
import FileEndpoints from "../../../api/FileEndpoints";
import FileDownloadHelper from "../../../helpers/FileDownloadHelper";

class Note extends React.Component {
    render() {

        const { classes } = this.props;

        return (
            <div style={{ textAlign: "left" }}>
                <div style={{ border: '1px solid rgba(0, 0, 0, 0.12)', display: 'flex', flexDirection: 'column', borderRadius: 8 }}>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        padding: 10,
                        borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
                        borderTopLeftRadius: 8,
                        borderTopRightRadius: 8
                    }}
                        className={this.props.color ? classes[this.props.color + "CardHeader"] : classes.primaryCardHeader}
                    >
                        {
                            this.props.user ?
                                <>
                                    <UserImage {...this.props.user} />
                                    <div style={{ flex: 1, display: "flex", paddingLeft: 16, justifyContent: 'center', alignItems: 'flex-start', flexDirection: 'column', color: '#ffffff' }}>
                                        <strong>{this.props.user.name} {this.props.user.surname || ""}</strong>
                                        <span>{moment(this.props.when).format('D MMMM YYYY @ HH:mm')}</span>
                                    </div>
                                </>
                                : null
                        }
                    </div>
                    <div style={{ whiteSpace: 'pre-wrap', padding: 20, fontWeight: 'normal', flex: 1 }}>
                        {this.props.message}
                    </div>
                    {
                        this.props.uploads && this.props.uploads.length > 0 ?
                            <div style={{ margin: 10, padding: 5, boxShadow: 'inset 0px 0px 28px -8px rgba(0,0,0,0.75)', backgroundColor: '#f7f7f7', borderRadius: 5, display: 'flex', flexWrap: 'wrap', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'space-evenly', alignContent: 'space-around' }}>
                                {
                                    this.props.uploads.map(file => {
                                        return (
                                            <FileBlock
                                                key={file.id}
                                                shared={file.shared}
                                                fileType={file.original_name.split('.').pop().toLowerCase()}
                                                fileName={file.original_name}
                                                image={
                                                    file.original_name.split('.').pop().toLowerCase() === 'jpg'
                                                        ||
                                                        file.original_name.split('.').pop().toLowerCase() === 'jpeg'
                                                        ||
                                                        file.original_name.split('.').pop().toLowerCase() === 'png' ?
                                                        "/api/shared/file?id=" + file.id : null
                                                }
                                                onClick={e => Api.fileDownload(FileEndpoints.download, file).then(({ data }) => FileDownloadHelper(data, file.mimeType, file.original_name))}
                                            />
                                        );
                                    })
                                }
                            </div>
                            :
                            null
                    }
                </div>
                <div style={{ paddingLeft: 20 }}>
                    {
                        this.props.replies && this.props.replies.map(
                            x => {
                                return (
                                    <Note {...x} color="info" classes={classes} />
                                );
                            }
                        )
                    }
                </div>

            </div>
        );
    }
}

export default withStyles(mainStyles)(Note);